import { IBaseEntry } from './interfaces/IBaseEntry';

export class BaseEntity implements IBaseEntry {
    public id: string;
    public created?: Date;
    public modified?: Date;
    public createdBy?: string;
    public createdUserName?: string;
    public modifiedBy?: string;
    public lastChange?: Date;
    public lastChangeBy?: string;
    public lastChangeUserName?: string;
    public modifedUserName?: string;
    constructor() {
    }
    public static GetEmptyGuid() {
        return '00000000-0000-0000-0000-000000000000';
    }
}
